/* eslint-disable prettier/prettier */
<template>
  <section class="section no-padding-mobile" id="p3-info">
    <div class="columns is-centered">
      <div class="column is-5-desktop is-10-tablet">
        <div class="modal-card" style="z-index: 2;">
          <div class="modal-card-head">
            <h1 class="title is-4 is-pink">
              <span>{{ $t('Procesos siguientes') }}</span>
            </h1>
          </div>
          <div class="modal-card-body colored container no-padding-mobile">
            <div class="container">
              <ol>
                <li class="section">
                  <img src="~@/assets/icons/profilecard.svg" alt="" />
                  <h2 class="title is-2">1</h2>
                  <p class="is-3" v-html="$t('INFOP1')"></p>
                </li>
                <li class="section">
                  <img src="~@/assets/icons/teleoperador.svg" alt="" />
                  <h2 class="title is-2">2</h2>
                  <p class="is-3" v-html="$t('INFOP2')"></p>
                </li>
                <li class="section">
                  <img src="~@/assets/icons/edit.svg" alt="" />
                  <h2 class="title is-2">3</h2>
                  <p class="is-3" v-html="$t('INFOP3')"></p>
                </li>
              </ol>
            </div>
            <div class="modal-card-footer">
              <div class="container is-flex">
                <div class="column is-7 is-12-mobile">
                  <p
                    style="font-weight: normal; color: #444;"
                    v-html="$t('INFOP4')"
                  ></p>
                </div>
                <div class="column is-5">
                  <button
                    @click="goToSignup()"
                    style="margin: auto;"
                    class="button is-primary is-full-w is-medium"
                  >
                    {{ $t(`Continuar`) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  methods: {
    goToSignup: function() {
      this.$router.push({ name: 'onBoard.neofintech.phase3.signup' })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content,
.modal-card {
  margin: auto;
  z-index: 99;
  border-radius: 20px;

  .modal-card-head,
  .modal-card-body {
    background: #ffffffaa;
    border: none;
  }
  .modal-card-head {
    p {
      text-align: center;
    }
    img {
      width: 300px;
    }
  }
}
@media (max-width: 1024px) {
  .modal-card {
    max-height: unset;
  }
  .modal-card-footer {
    padding: 20px 10px;
  }
}
.modal-card ol li {
  display: flex;

  &.section {
    border-style: solid solid none none;
    border-radius: 10px;
    border-color: var(--rosa-dark-eco);
    background-color: white;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 5px 10px -7px #00000055;
  }
  img {
    margin-right: 10px;
    min-width: 40px;
  }

  h2 {
    margin: auto 20px auto 0;
    color: var(--rosa-eco);
  }

  p {
    margin: auto 0;

    &.is-3 {
      color: #555;
      font-size: 17px;
      font-weight: 300;
      line-height: 1.1em;
    }
  }
}
.container.is-flex {
  flex-wrap: wrap;
}
</style>
